import { IInteriorDesignLibrary, IInteriorDesignLibraryItem } from '@ml/common';

export class InteriorDesignLibrarySet {
  GlobalDesigns: InteriorDesignGalleryImageVM[] = [];
  ClientDesigns: InteriorDesignGalleryImageVM[] = [];

  constructor(designSet: IInteriorDesignLibrary, baseUrl: string) {
    if (designSet.GlobalDesigns) {
      this.GlobalDesigns = designSet.GlobalDesigns.map(
        item => new InteriorDesignGalleryImageVM(baseUrl, item)
      );
    }
    if (designSet.ClientDesigns) {
      this.ClientDesigns = designSet.ClientDesigns.map(
        item => new InteriorDesignGalleryImageVM(baseUrl, item)
      );
    }
  }
}

export class BaseDesignGalleryImageVM {
  Id: number;
  PrimaryUrl: string;
  PrimaryThumbnailUrl: string;
  SortOrder: number;
  RoomTypeDisplayName: string;
  ImageDisplayName: string;
  RoomType?: string;
  DesignType?: string;
  SecondaryUrl?: string;
  SelectedImageType?: InteriorDesignGalleryImageType;
}

export class InteriorDesignGalleryImageVM extends BaseDesignGalleryImageVM {
  PrimaryThumbnailUrl: string;
  SecondaryThumbnailUrl?: string;
  PrimaryUrl: string;
  SecondaryUrl?: string;
  Id: number;
  BaseUrl?: string;
  ClientId?: number;
  ProjectId?: number;
  ClientVirtualDirectory?: string;
  RoomType?: string;
  DesignType?: string;
  SourceDirectory?: string;
  ImageFileName?: string;
  RoomTypeDisplayName: string;
  ImageDisplayName: string;
  SortOrder: number;

  constructor(baseUrl: string, item: IInteriorDesignLibraryItem) {
    super();
    this.BaseUrl = baseUrl;
    this.Id = item.InteriorDesignLibraryId;
    this.ClientId = item.ClientId;
    this.ProjectId = item.ProjectId;
    this.SourceDirectory = item.SourceDirectory;
    this.ImageFileName = item.ImageFileName;
    this.PrimaryThumbnailUrl = `${baseUrl}${item.ClientVirtualDirectory}/interiorDesign/thumbs/${item.ImageFileName}`;
    this.SecondaryThumbnailUrl = `${baseUrl}${item.ClientVirtualDirectory}/interiorDesign/thumbs/${item.SecondaryImageFileName}`;
    this.PrimaryUrl = `${baseUrl}${item.ClientVirtualDirectory}/interiorDesign/${item.ImageFileName}`;
    this.SecondaryUrl = `${baseUrl}${item.ClientVirtualDirectory}/interiorDesign/${item.SecondaryImageFileName}`;
    this.RoomType = item.RoomType;
    this.DesignType = item.DesignType;
    this.RoomTypeDisplayName = GalleryRoomTypeMappings[item.RoomType] || item.RoomType;
    this.ImageDisplayName = this.getImageDisplayName();
    this.SortOrder = GalleryRoomTypeMappingsSortOrder[item.RoomType] || 0;
  }

  private getImageDisplayName() {
    const designNumber = this.ImageFileName.match(/(\d+)/);
    let imageDisplayName = `${this.DesignType} ${this.RoomTypeDisplayName}`;
    if (designNumber && !isNaN(Number(designNumber[0]))) {
      const parsedNumber = parseInt(designNumber[0], 10);
      imageDisplayName += ` ${parsedNumber}`;
    }
    return imageDisplayName
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}

export enum InteriorDesignGalleryImageType {
  GreyBox = 'GreyBox',
  Staged = 'Staged',
  Standard = 'Standard',
  Soft = 'Soft'
}

export enum GalleryRoomTypeMappings {
  bath = 'Bathroom',
  primarybedroom = 'Bedroom - Primary',
  bed = 'Bedroom - Secondary',
  nursery = 'Bedroom - Nursery',
  youthbed = 'Bedroom - Kids',
  dining = 'Dining Room',
  artroom = 'Flex - Art Room',
  classroom = 'Flex - Classroom',
  fitness = 'Flex - Fitness',
  gameroom = 'Flex - Game Room',
  playroom = 'Flex - Playroom',
  study = 'Flex - Study',
  foyer = 'Foyer',
  kitchen = 'Kitchen',
  laundry = 'Laundry Room',
  livingroom = 'Living Room',
  loft = 'Loft',
  outdoorliving = 'Outdoor Living'
}

export enum GalleryRoomTypeMappingsSortOrder {
  bath = 1,
  primarybedroom = 2,
  bed = 3,
  nursery = 4,
  youthbed = 5,
  dining = 6,
  artroom = 7,
  classroom = 8,
  fitness = 9,
  gameroom = 10,
  playroom = 11,
  study = 12,
  foyer = 13,
  kitchen = 14,
  laundry = 15,
  livingroom = 16,
  loft = 17,
  outdoorliving = 18
}

export enum InteriorOrderAccordionContentTypes {
  Designs = 'Designs',
  Environment = 'Environment',
  CameraAngle = 'CameraAngle',
  Rooms = 'Rooms'
}

export enum CameraAngleSelectionTypes {
  Angled = 'Angled',
  Straight = 'Straight On'
}

export class InteriorEnvironmentAndCameraAngleVMs {
  CameraAngles: BaseDesignGalleryImageVM[] = [
    {
      Id: 1,
      PrimaryUrl: '/assets/images/interiors/cameraAngles/Bedroom_Angled.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/cameraAngles/Bedroom_Angled.jpg',
      SortOrder: 1,
      RoomTypeDisplayName: CameraAngleSelectionTypes.Angled,
      ImageDisplayName: 'Bedroom - Angled'
    },
    {
      Id: 2,
      PrimaryUrl: '/assets/images/interiors/cameraAngles/Bedroom_Straight.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/cameraAngles/Bedroom_Straight.jpg',
      SortOrder: 2,
      RoomTypeDisplayName: CameraAngleSelectionTypes.Straight,
      ImageDisplayName: 'Bedroom - Straight On'
    },
    {
      Id: 3,
      PrimaryUrl: '/assets/images/interiors/cameraAngles/Living_Angled.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/cameraAngles/Living_Angled.jpg',
      SortOrder: 3,
      RoomTypeDisplayName: CameraAngleSelectionTypes.Angled,
      ImageDisplayName: 'Living Room - Angled'
    },
    {
      Id: 4,
      PrimaryUrl: '/assets/images/interiors/cameraAngles/Living_Straight.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/cameraAngles/Living_Straight.jpg',
      SortOrder: 4,
      RoomTypeDisplayName: CameraAngleSelectionTypes.Straight,
      ImageDisplayName: 'Living Room - Straight On'
    }
  ];
  Environments: BaseDesignGalleryImageVM[] = [
    {
      Id: 5,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Alpine_Mountains.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Alpine_Mountains.jpg',
      SecondaryUrl:
        '/assets/images/interiors/interiorEnvironments/Alpine_Mountains_OVEREXPOSED.jpg',
      SortOrder: 1,
      RoomTypeDisplayName: 'Alpine Mountains',
      ImageDisplayName: 'Alpine Mountains'
    },
    {
      Id: 6,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Desert_Scrub.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Desert_Scrub.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/Desert_Scrub_OVEREXPOSED.jpg',
      SortOrder: 2,
      RoomTypeDisplayName: 'Desert Scrub',
      ImageDisplayName: 'Desert Scrub'
    },
    {
      Id: 7,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Fir.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Fir.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/Fir_OVEREXPOSED.jpg',
      SortOrder: 3,
      RoomTypeDisplayName: 'Fir',
      ImageDisplayName: 'Fir'
    },
    {
      Id: 8,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_OVEREXPOSED.jpg',
      SortOrder: 4,
      RoomTypeDisplayName: 'Hard Wood',
      ImageDisplayName: 'Hard Wood'
    },
    {
      Id: 9,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_Palm.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_Palm.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_Palm_OVEREXPOSED.jpg',
      SortOrder: 5,
      RoomTypeDisplayName: 'Hard Wood Palm',
      ImageDisplayName: 'Hard Wood Palm'
    },
    {
      Id: 10,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_South.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_South.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_South_OVEREXPOSED.jpg',
      SortOrder: 6,
      RoomTypeDisplayName: 'Hard Wood South',
      ImageDisplayName: 'Hard Wood South'
    },
    {
      Id: 11,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_South_Palm.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Hard_Wood_South_Palm.jpg',
      SecondaryUrl:
        '/assets/images/interiors/interiorEnvironments/Hard_Wood_South_Palm_OVEREXPOSED.jpg',
      SortOrder: 7,
      RoomTypeDisplayName: 'Hard Wood South Palm',
      ImageDisplayName: 'Hard Wood South Palm'
    },
    {
      Id: 12,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Midwest_Grass_Hills.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Midwest_Grass_Hills.jpg',
      SecondaryUrl:
        '/assets/images/interiors/interiorEnvironments/Midwest_Grass_Hills_OVEREXPOSED.jpg',
      SortOrder: 8,
      RoomTypeDisplayName: 'Midwest Grass Hills',
      ImageDisplayName: 'Midwest Grass Hills'
    },
    {
      Id: 13,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/Plains_Dry_Grass.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/Plains_Dry_Grass.jpg',
      SecondaryUrl:
        '/assets/images/interiors/interiorEnvironments/Plains_Dry_Grass_OVEREXPOSED.jpg',
      SortOrder: 9,
      RoomTypeDisplayName: 'Plains Dry Grass',
      ImageDisplayName: 'Plains Dry Grass'
    },
    {
      Id: 14,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/West_Desert.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/West_Desert.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/West_Desert_OVEREXPOSED.jpg',
      SortOrder: 10,
      RoomTypeDisplayName: 'West Desert',
      ImageDisplayName: 'West Desert'
    },
    {
      Id: 15,
      PrimaryUrl: '/assets/images/interiors/interiorEnvironments/West_Red_Desert.jpg',
      PrimaryThumbnailUrl: '/assets/images/interiors/interiorEnvironments/West_Red_Desert.jpg',
      SecondaryUrl: '/assets/images/interiors/interiorEnvironments/West_Red_Desert_OVEREXPOSED.jpg',
      SortOrder: 11,
      RoomTypeDisplayName: 'West Red Desert',
      ImageDisplayName: 'West Red Desert'
    }
  ];
}
